export default "__VITE_ASSET__DP52Khn___"